<template>
    <div class="all">
        <!-- 会员导航 -->
        <vipMenu></vipMenu>
        <!-- 预警信息列表 -->
        <div class="warp mt20">
            <div class="warp-body">
                <table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
                    <colgroup>
                        <col width="30%">
                        <col width="15%">
                        <col width="15%">
                        <col width="15%">
                        <col width="15%">
                        <col width="15%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>订单号</th>
                            <th>类型</th>
                            <th>详情</th>
                            <th>金额</th>
                            <th>时间</th>
                            <th>状态</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in list">
                            <td>{{item.orderNum}}</td>
                            <td>{{item.typeName}}</td>
                            <td>{{item.remark}}</td>
                            <td>{{item.qingBeiNum}}</td>
                            <td>{{item.createTime}}</td>
                            <td>{{item.stateName}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="no-data" v-if="nodata"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                <!-- 分页 -->
                <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            </div>
        </div>
	</div>
</template>
<script>
import page from '../../components/page.vue';
import vipMenu from './vipMenu.vue';
export default {
    components: {page,vipMenu},
    data() {
        return {
            page:1,
		    limit:'',//每页显示条数
            totalCount:'',//总页数
            nodata:'',//暂无数据
            list:[]//列表
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.getNewsList();
        }) 
    },
    created() {
		
    },
    methods: {
        // 获取充值记录
        getNewsList () {
            let that = this;
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('user/member/recharge-records',{page:that.page,perpage:that.limit},r =>{
                that.$parent.returnCode(r,function(){
                    that.$parent.showLoad = false;
                    that.list = r.data.list;
                    that.totalCount = r.data.total;
                    that.limit = r.data.limit;
                    if(r.data.list.length <= 0){//没有数据
                        that.nodata = true;
                    }else{
                        that.nodata = false;
                    }
                })
            })
        },
        // 翻页
        getTableData () {
            let that = this;
            that.getNewsList();
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/rechargeRecord.vue